module.exports = __webpack_public_path__ + "static/media/envelope.e3d9ea51.svg";